import React, {ReactNode} from "react";
import {FontAwesomeIcon} from "@fortawesome/react-fontawesome";
import {faSpinner} from "@fortawesome/pro-regular-svg-icons";

import ProjectEditButton from "@/components/buttons/project-edit-button";
import {ButtonProps} from "@/components/buttons/button";

interface LoadingButtonLockDependantProps extends ButtonProps {
    disabled?: boolean;
    isLoading: boolean;
    isLoadingMessage?: ReactNode;
}

const LoadingButtonLockDependant: React.FC<LoadingButtonLockDependantProps> = ({ variant, size, isLoading, isLoadingMessage = undefined, disabled = false, type = 'button', className, children, ...props }) => (
        <ProjectEditButton disabled={disabled || isLoading} type={type}
                             className={className}
                             variant={variant}
                             size={size}
                             {...props}>
            {isLoading ? <div className='flex flex-row gap-x-2 items-center'><FontAwesomeIcon icon={faSpinner} spin /> {isLoadingMessage}</div> : children}
        </ProjectEditButton>
    )

export default LoadingButtonLockDependant;